"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = exports.Breadcrumb = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styles = require("@material-ui/styles");
var _Clamp = _interopRequireDefault(require("../../Clamp/Clamp"));
var _excluded = ["to"],
  _excluded2 = ["children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type LocationShape } from 'react-router-dom';*/
var useStyles = exports.useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginBottom: '.5rem'
    },
    breadcrumb: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.link), theme.typography.header5), {}, {
      display: 'inline-flex',
      alignItems: 'center',
      maxWidth: '100%'
    })
  };
});
/*:: type LinkProps = {|
  'data-testid'?: string,
  children: React.Node,
  onClick?: (...args: Array<any>) => any,
  to?: string | LocationShape
|};*/
var BreadcrumbLink = function BreadcrumbLink(_ref /*:: */) {
  var to = _ref /*:: */.to,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return to === undefined ? /*#__PURE__*/React.createElement("button", props) : /*#__PURE__*/React.createElement(_reactRouterDom.Link, (0, _extends2.default)({}, props, {
    to: to
  }));
};
BreadcrumbLink.displayName = 'BreadcrumbLink';
/*:: type Props = {|
  'data-testid'?: string,
  children: string,
  onClick?: (...args: Array<any>) => any,
  to?: string | LocationShape
|};*/
var Breadcrumb = exports.Breadcrumb = function Breadcrumb(_ref2 /*:: */) {
  var children = _ref2 /*:: */.children,
    props = (0, _objectWithoutProperties2.default)(_ref2 /*:: */, _excluded2);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(BreadcrumbLink, props, /*#__PURE__*/React.createElement("span", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(_Clamp.default, {
    clamp: 1
  }, children))));
};
var _default = exports.default = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map